@if (!showPage()) {
  <div class="flex flex-col w-full h-full border border-color-light-shade border-solid border-y-0 border-r-0">
    <div
      class="flex-none flex px-6 py-3 flex-row items-center justify-between w-full min-h-16 h-16 border-b-[thin] border-color-light-shade border-solid border-x-0 border-t-0 gap-3"
    >
      <p class="text-color-neutral text-sm font-semibold p-0 m-0 truncate">
        {{ assetsTreeService.selectedItem()?.name }}
      </p>
      <div class="flex-none flex flex-row items-center gap-3">
        <fc-menu size="xs" theme="outline" position="right-4" [title]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.TITLE' | translate">
          <fc-menu-option
            [icon]="'mode_edit'"
            [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.EDIT' | translate"
            (clickEvent)="emitEvent('edit')"
            [isFirst]="true"
            [disabled]="
              assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Equipment
                ? !assetsTreeService.hasEquipmentEditPermission()
                : !assetsTreeService.hasLocationEditPermission()
            "
            [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
            [isLast]="assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Equipment"
          ></fc-menu-option>
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Location) {
            <fc-menu-option
              [icon]="'gite'"
              [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.NEW_SECTOR' | translate"
              (clickEvent)="emitEvent('addSector')"
              [disabled]="!assetsTreeService.hasLocationEditPermission()"
              [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
            ></fc-menu-option>
            <fc-menu-option
              [icon]="'precision_manufacturing'"
              [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.NEW_EQUIPMENT' | translate"
              (clickEvent)="emitEvent('addEquipment')"
              [isLast]="true"
              [disabled]="!assetsTreeService.hasEquipmentCreatePermission()"
              [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
            ></fc-menu-option>
          }
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.LocationSector) {
            <fc-menu-option
              [icon]="'meeting_room'"
              [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.NEW_ENVIRONMENT' | translate"
              (clickEvent)="emitEvent('addEnvironment')"
              [disabled]="!assetsTreeService.hasLocationEditPermission()"
              [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
            ></fc-menu-option>
            <fc-menu-option
              [icon]="'precision_manufacturing'"
              [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.LINK_EQUIPMENT' | translate"
              (clickEvent)="emitEvent('linkEquipment')"
              [disabled]="!assetsTreeService.hasLocationEditPermission()"
              [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
            ></fc-menu-option>
            @if (!details()?.archived) {
              <fc-menu-option
                [icon]="'archive'"
                [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.ARCHIVE_LOCATION_SECTOR' | translate"
                (clickEvent)="emitEvent('archive')"
                [disabled]="!assetsTreeService.hasLocationEditPermission()"
                [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
                [isLast]="true"
              ></fc-menu-option>
            }
            @if (details()?.archived) {
              <fc-menu-option
                [icon]="'unarchive'"
                [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.UNARCHIVE_LOCATION_SECTOR' | translate"
                (clickEvent)="emitEvent('archive')"
                [disabled]="!assetsTreeService.hasLocationEditPermission()"
                [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
                [isLast]="true"
              ></fc-menu-option>
            }
          }
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.LocationEnvironment) {
            <fc-menu-option
              [icon]="'precision_manufacturing'"
              [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.LINK_EQUIPMENT' | translate"
              (clickEvent)="emitEvent('linkEquipment')"
              [disabled]="!assetsTreeService.hasLocationEditPermission()"
              [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
            ></fc-menu-option>
            @if (!details()?.archived) {
              <fc-menu-option
                [icon]="'archive'"
                [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.ARCHIVE_LOCATION_ENVIRONMENT' | translate"
                (clickEvent)="emitEvent('archive')"
                [disabled]="!assetsTreeService.hasLocationEditPermission()"
                [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
                [isLast]="true"
              ></fc-menu-option>
            }
            @if (details()?.archived) {
              <fc-menu-option
                [icon]="'unarchive'"
                [text]="'ASSETS_TREE.DETAILS_SECTION.ACTIONS.UNARCHIVE_LOCATION_ENVIRONMENT' | translate"
                (clickEvent)="emitEvent('archive')"
                [disabled]="!assetsTreeService.hasLocationEditPermission()"
                [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
                [isLast]="true"
              ></fc-menu-option>
            }
          }
        </fc-menu>
        <palantir-button icon="close-outline" size="xs" theme="outline" layout="icon" (click)="close()"></palantir-button>
      </div>
    </div>
    <ng-scrollbar class="grow w-full h-full overflow-auto relative" [visibility]="'hover'" autoHeightDisabled="false">
      <div class="w-full gap-4 p-5 flex flex-col">
        <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Location) {
            <p class="font-medium text-color-normal p-0 m-0">
              {{ 'ASSETS_TREE.DETAILS_SECTION.LOCATION.TITLE' | translate }}
            </p>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION.NAME' | translate"
              [value]="details()?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION.DOCUMENT_NUMBER' | translate"
              [value]="details()?.documentNumber | formatDocumentNumber"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION.SEGMENTS' | translate"
              [value]="details()?.segments | joinNames"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION.LOCATION_GROUP' | translate"
              [value]="details()?.group?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION.NOTES' | translate"
              [value]="details()?.notes"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION.ADDRESS' | translate"
              [value]="details()?.address?.formattedAddress"
              [isLoading]="isLoading()"
            ></app-detail-item>
          }
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.LocationSector) {
            <p class="font-medium text-color-normal p-0 m-0">
              {{ 'ASSETS_TREE.DETAILS_SECTION.LOCATION_SECTOR.TITLE' | translate }}
            </p>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_SECTOR.NAME' | translate"
              [value]="details()?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_SECTOR.LOCATION' | translate"
              [value]="details()?.location?.address?.formattedAddress"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_SECTOR.DESCRIPTION' | translate"
              [value]="details()?.description"
              [isLoading]="isLoading()"
            ></app-detail-item>
          }
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.LocationEnvironment) {
            <p class="font-medium text-color-normal p-0 m-0">
              {{ 'ASSETS_TREE.DETAILS_SECTION.LOCATION_ENVIRONMENT.TITLE' | translate }}
            </p>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_ENVIRONMENT.NAME' | translate"
              [value]="details()?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_ENVIRONMENT.QR_CODE' | translate"
              [value]="details()?.qrCode"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_ENVIRONMENT.LOCATION' | translate"
              [value]="details()?.locationSector?.location?.address?.formattedAddress"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_ENVIRONMENT.SECTOR' | translate"
              [value]="details()?.locationSector?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.LOCATION_ENVIRONMENT.DESCRIPTION' | translate"
              [value]="details()?.description"
              [isLoading]="isLoading()"
            ></app-detail-item>
          }
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Equipment) {
            <p class="font-medium text-color-normal p-0 m-0">
              {{ 'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.TITLE' | translate }}
            </p>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.NAME' | translate"
              [value]="details()?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.TYPE' | translate"
              [value]="details()?.type?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.SERIAL_NUMBER' | translate"
              [value]="details()?.number"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.QR_CODE' | translate"
              [value]="details()?.qrCode"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.PURCHASED_AT' | translate"
              [value]="details()?.purchasedAt | date: 'dd/MM/yyyy'"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.INSTALLED_AT' | translate"
              [value]="details()?.installedAt | date: 'dd/MM/yyyy'"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.LOCATION' | translate"
              [value]="details()?.location?.address?.formattedAddress"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.SECTOR' | translate"
              [value]="details()?.locationSector?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.ENVIRONMENT' | translate"
              [value]="details()?.locationEnvironment?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.NOTES' | translate"
              [value]="details()?.notes"
              [isLoading]="isLoading()"
            ></app-detail-item>
          }
          @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Equipment && details() && details().warranties?.length) {
            <p class="font-medium text-color-normal p-0 m-0">
              {{ 'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.TITLE' | translate }}
            </p>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.NAME' | translate"
              [value]="details()?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.TYPE' | translate"
              [value]="details()?.type?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.SERIAL_NUMBER' | translate"
              [value]="details()?.number"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.QR_CODE' | translate"
              [value]="details()?.qrCode"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.PURCHASED_AT' | translate"
              [value]="details()?.purchasedAt | date: 'dd/MM/yyyy'"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.INSTALLED_AT' | translate"
              [value]="details()?.installedAt | date: 'dd/MM/yyyy'"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.LOCATION' | translate"
              [value]="details()?.location?.address?.formattedAddress"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.SECTOR' | translate"
              [value]="details()?.locationSector?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.ENVIRONMENT' | translate"
              [value]="details()?.locationEnvironment?.name"
              [isLoading]="isLoading()"
            ></app-detail-item>
            <app-detail-item
              [title]="'ASSETS_TREE.DETAILS_SECTION.EQUIPMENT.NOTES' | translate"
              [value]="details()?.notes"
              [isLoading]="isLoading()"
            ></app-detail-item>
          }
        </div>
        @if (isLoading()) {
          <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
            <palantir-skeleton class="w-full h-5 rounded-lg"></palantir-skeleton>
            <div class="w-full flex flex-col gap-2">
              <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
              <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
              <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
            </div>
          </div>
          @if (assetsTreeService.selectedItem()?.type !== treeItemTypeEnum.Equipment) {
            <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
              <palantir-skeleton class="w-full h-5 rounded-lg"></palantir-skeleton>
              <div class="w-full flex flex-col gap-2">
                <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
              </div>
            </div>
          }
        }
        @if (!isLoading() && assetsTreeService.selectedItem()?.type !== treeItemTypeEnum.Equipment && equipments()?.totalCount) {
          <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
            <p class="p-0 m-0 text-color-normal font-medium text-sm">
              {{ 'ASSETS_TREE.DETAILS_SECTION.EQUIPMENTS.TITLE' | translate: { total: equipments()?.totalCount } }}
            </p>
            <div class="w-full flex flex-col gap-2">
              @for (equipment of equipments()?.items; track $index; let i = $index) {
                <div
                  class="cursor-pointer w-full flex flex-row items-center justify-between border border-color-light-shade border-solid p-3 gap-3 rounded-xl hover:bg-color-surface hover:border-[#99BBFF] transition-all ease-in-out duration-300"
                  (mouseover)="isHoveringEquipmentIndex.set(i)"
                  (mouseout)="isHoveringEquipmentIndex.set(-1)"
                  (click)="emitEvent('viewEquipment', equipment.id)"
                >
                  @if (!equipment.imageUrl) {
                    <div
                      class="w-8 h-8 flex-none rounded-full flex items-center justify-center transition-all ease-in-out duration-300"
                      [ngClass]="{
                        'bg-white': isHoveringEquipmentIndex() === i,
                        'bg-color-surface': isHoveringEquipmentIndex() !== i,
                      }"
                    >
                      <mat-icon fontSet="material-icons-outlined" class="max-h-5 h-5 max-w-5 w-5 text-[20px] text-color-primary">
                        precision_manufacturing
                      </mat-icon>
                    </div>
                  }
                  @if (equipment.imageUrl) {
                    <img
                      [src]="equipment.imageUrl"
                      [alt]="equipment.name"
                      class="flex-none w-8 h-8 rounded-full object-cover bg-color-surface"
                    />
                  }
                  <p class="grow truncate p-0 m-0 text-color-neutral text-sm">
                    {{ equipment.name }}
                  </p>
                  @if (equipment.archived) {
                    <div
                      class="flex-none flex flex-row items-center gap-1 p-[6px] rounded-full transition-all ease-in-out duration-300"
                      [style.backgroundColor]="
                        isHoveringEquipmentIndex() === i ? '#FFFFFF' : maintenanceStatusColorsOpacity10.archived
                      "
                    >
                      <div class="w-2 h-2 rounded-full bg-color-old-gray-50"></div>
                      <p class="p-0 m-0 text-color-old-gray-50 font-medium text-xs">
                        {{ 'ASSETS_TREE.TREE_SECTION.TREE_VIEW.ARCHIVED' | translate }}
                      </p>
                    </div>
                  }
                </div>
              }
            </div>
            @if (equipments()?.pageInfo?.hasNextPage) {
              <p class="p-0 m-0 text-color-primary text-sm font-medium text-center cursor-pointer" (click)="openEquipmentsPage()">
                {{ 'ASSETS_TREE.DETAILS_SECTION.ACTIONS.VIEW_MORE' | translate }}
              </p>
            }
          </div>
        }
        @if (!isLoading() && maintenances()?.totalCount) {
          <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
            <p class="p-0 m-0 text-color-normal font-medium text-sm">
              {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.TITLE' | translate: { total: maintenances()?.totalCount } }}
            </p>
            <div class="w-full flex flex-col gap-2">
              @for (maintenance of maintenances()?.items; track $index; let i = $index) {
                <div
                  class="cursor-pointer w-full flex flex-row items-center justify-between border border-color-light-shade border-solid p-3 gap-3 rounded-xl hover:bg-color-surface hover:border-[#99BBFF] transition-all ease-in-out duration-300"
                  (mouseover)="isHoveringMaintenanceIndex.set(i)"
                  (mouseout)="isHoveringMaintenanceIndex.set(-1)"
                  (click)="emitEvent('viewMaintenance', maintenance.id)"
                >
                  <div
                    class="w-8 h-8 flex-none rounded-full flex items-center justify-center transition-all ease-in-out duration-300"
                    [ngClass]="{
                      'bg-white': isHoveringMaintenanceIndex() === i,
                      'bg-color-surface': isHoveringMaintenanceIndex() !== i,
                    }"
                  >
                    <mat-icon fontSet="material-icons-outlined" class="max-h-5 h-5 max-w-5 w-5 text-[20px] text-color-primary">
                      business_center
                    </mat-icon>
                  </div>
                  <p class="grow truncate p-0 m-0 text-color-neutral text-sm">
                    {{ maintenance.number }}
                  </p>
                  <div
                    class="flex-none flex flex-row px-[10px] py-1 rounded-full gap-[6px] items-center transition-all ease-in-out duration-300"
                    [style.backgroundColor]="
                      isHoveringMaintenanceIndex() === i ? '#FFFFFF' : maintenanceStatusColorsOpacity10[maintenance.status]
                    "
                  >
                    <div class="w-2 h-2 rounded-full" [style.backgroundColor]="maintenanceStatusColors[maintenance.status]"></div>
                    <p class="p-0 m-0 text-xs font-medium" [style.color]="maintenanceStatusColors[maintenance.status]">
                      {{ maintenance.status | translateMaintenanceStatus }}
                    </p>
                  </div>
                </div>
              }
            </div>
            @if (maintenances()?.pageInfo?.hasNextPage) {
              <p class="p-0 m-0 text-color-primary text-sm font-medium text-center cursor-pointer" (click)="openMaintenancesPage()">
                {{ 'ASSETS_TREE.DETAILS_SECTION.ACTIONS.VIEW_MORE' | translate }}
              </p>
            }
          </div>
        }
      </div>
    </ng-scrollbar>
    @if (assetsTreeService.selectedItem()?.type === treeItemTypeEnum.Equipment && details() && details().warranties?.length) {
      <ng-scrollbar class="grow w-full h-full overflow-auto relative" [visibility]="'hover'" autoHeightDisabled="false">
        <div class="w-full gap-4 p-5 flex flex-col">
          <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
            <ng-container>
              <p class="font-medium text-color-normal p-0 m-0">
                {{ 'ASSETS_TREE.DETAILS_SECTION.WARRANTIES.TITLE' | translate }}
              </p>
              @for (warranty of details().warranties; track $index) {
                <app-warranty-item
                  (click)="emitEvent('viewEquipmentWarranties', details().id)"
                  class="cursor-pointer"
                  [warranty]="warranty"
                  [isLoading]="isLoading()"
                ></app-warranty-item>
              }
            </ng-container>
          </div>
          @if (isLoading()) {
            <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
              <palantir-skeleton class="w-full h-5 rounded-lg"></palantir-skeleton>
              <div class="w-full flex flex-col gap-2">
                <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
              </div>
            </div>
            @if (assetsTreeService.selectedItem()?.type !== treeItemTypeEnum.Equipment) {
              <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
                <palantir-skeleton class="w-full h-5 rounded-lg"></palantir-skeleton>
                <div class="w-full flex flex-col gap-2">
                  <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                  <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                  <palantir-skeleton class="w-full h-14 rounded-xl"></palantir-skeleton>
                </div>
              </div>
            }
          }
          @if (!isLoading() && assetsTreeService.selectedItem()?.type !== treeItemTypeEnum.Equipment && equipments()?.totalCount) {
            <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
              <p class="p-0 m-0 text-color-normal font-medium text-sm">
                {{ 'ASSETS_TREE.DETAILS_SECTION.EQUIPMENTS.TITLE' | translate: { total: equipments()?.totalCount } }}
              </p>
              <div class="w-full flex flex-col gap-2">
                @for (equipment of equipments()?.items; track $index; let i = $index) {
                  <div
                    class="cursor-pointer w-full flex flex-row items-center justify-between border border-color-light-shade border-solid p-3 gap-3 rounded-xl hover:bg-color-surface hover:border-[#99BBFF] transition-all ease-in-out duration-300"
                    (mouseover)="isHoveringEquipmentIndex.set(i)"
                    (mouseout)="isHoveringEquipmentIndex.set(-1)"
                    (click)="emitEvent('viewEquipment', equipment.id)"
                  >
                    @if (!equipment.imageUrl) {
                      <div
                        class="w-8 h-8 flex-none rounded-full flex items-center justify-center transition-all ease-in-out duration-300"
                        [ngClass]="{
                          'bg-white': isHoveringEquipmentIndex() === i,
                          'bg-color-surface': isHoveringEquipmentIndex() !== i,
                        }"
                      >
                        <mat-icon fontSet="material-icons-outlined" class="max-h-5 h-5 max-w-5 w-5 text-[20px] text-color-primary">
                          precision_manufacturing
                        </mat-icon>
                      </div>
                    }
                    @if (equipment.imageUrl) {
                      <img
                        [src]="equipment.imageUrl"
                        [alt]="equipment.name"
                        class="flex-none w-8 h-8 rounded-full object-cover bg-color-surface"
                      />
                    }
                    <p class="grow truncate p-0 m-0 text-color-neutral text-sm">
                      {{ equipment.name }}
                    </p>
                    @if (equipment.archived) {
                      <div
                        class="flex-none flex flex-row items-center gap-1 p-[6px] rounded-full transition-all ease-in-out duration-300"
                        [style.backgroundColor]="
                          isHoveringEquipmentIndex() === i ? '#FFFFFF' : maintenanceStatusColorsOpacity10.archived
                        "
                      >
                        <div class="w-2 h-2 rounded-full bg-color-old-gray-50"></div>
                        <p class="p-0 m-0 text-color-old-gray-50 font-medium text-xs">
                          {{ 'ASSETS_TREE.TREE_SECTION.TREE_VIEW.ARCHIVED' | translate }}
                        </p>
                      </div>
                    }
                  </div>
                }
              </div>
              @if (equipments()?.pageInfo?.hasNextPage) {
                <p class="p-0 m-0 text-color-primary text-sm font-medium text-center cursor-pointer" (click)="openEquipmentsPage()">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.ACTIONS.VIEW_MORE' | translate }}
                </p>
              }
            </div>
          }
          @if (!isLoading() && maintenances()?.totalCount) {
            <div class="w-full p-6 gap-6 flex flex-col bg-white rounded-xl">
              <p class="p-0 m-0 text-color-normal font-medium text-sm">
                {{ 'ASSETS_TREE.DETAILS_SECTION.MAINTENANCES.TITLE' | translate: { total: maintenances()?.totalCount } }}
              </p>
              <div class="w-full flex flex-col gap-2">
                @for (maintenance of maintenances()?.items; track $index; let i = $index) {
                  <div
                    class="cursor-pointer w-full flex flex-row items-center justify-between border border-color-light-shade border-solid p-3 gap-3 rounded-xl hover:bg-color-surface hover:border-[#99BBFF] transition-all ease-in-out duration-300"
                    (mouseover)="isHoveringMaintenanceIndex.set(i)"
                    (mouseout)="isHoveringMaintenanceIndex.set(-1)"
                    (click)="emitEvent('viewMaintenance', maintenance.id)"
                  >
                    <div
                      class="w-8 h-8 flex-none rounded-full flex items-center justify-center transition-all ease-in-out duration-300"
                      [ngClass]="{
                        'bg-white': isHoveringMaintenanceIndex() === i,
                        'bg-color-surface': isHoveringMaintenanceIndex() !== i,
                      }"
                    >
                      <mat-icon fontSet="material-icons-outlined" class="max-h-5 h-5 max-w-5 w-5 text-[20px] text-color-primary">
                        business_center
                      </mat-icon>
                    </div>
                    <p class="grow truncate p-0 m-0 text-color-neutral text-sm">
                      {{ maintenance.number }}
                    </p>
                    <div
                      class="flex-none flex flex-row px-[10px] py-1 rounded-full gap-[6px] items-center transition-all ease-in-out duration-300"
                      [style.backgroundColor]="
                        isHoveringMaintenanceIndex() === i ? '#FFFFFF' : maintenanceStatusColorsOpacity10[maintenance.status]
                      "
                    >
                      <div class="w-2 h-2 rounded-full" [style.backgroundColor]="maintenanceStatusColors[maintenance.status]"></div>
                      <p class="p-0 m-0 text-xs font-medium" [style.color]="maintenanceStatusColors[maintenance.status]">
                        {{ maintenance.status | translateMaintenanceStatus }}
                      </p>
                    </div>
                  </div>
                }
              </div>
              @if (maintenances()?.pageInfo?.hasNextPage) {
                <p class="p-0 m-0 text-color-primary text-sm font-medium text-center cursor-pointer" (click)="openMaintenancesPage()">
                  {{ 'ASSETS_TREE.DETAILS_SECTION.ACTIONS.VIEW_MORE' | translate }}
                </p>
              }
            </div>
          }
        </div>
      </ng-scrollbar>
    }
  </div>
}

@if (showPage()) {
  <app-detail-page [options]="pageOptions()" (closePage)="closePage()"></app-detail-page>
}
